
// import barba from '@barba/core';

export default class{

	constructor(){
        this.ajaxZipUrl = "https://ajaxzip3.github.io/ajaxzip3.js";
        this.form_class = '.mw_wp_form.mw_wp_form_input'
        this.form_confirm_class = '.mw_wp_form.mw_wp_form_confirm'
        this.agree()
        this.disabled_ime()
        this.fileInput()
        this.require()
        this.readonly()
        this.customHome()
        this.customPresent()
        this.customCarConsider()
        this.customCarSupport()
        this.customConsultation()
        this.customEstimate01()
        this.customEstimate02()
        this.customGoods()
        this.customOther()
        this.checkMail()
        //this.requiredRemove()

        this.appendApi()
        this.zip()


        this.select_multi_dates()
    }
    
    agree(){


        const agreeCheckConfirm = document.querySelector( this.form_confirm_class + ' #agree-check');
        
        if(agreeCheckConfirm){
            agreeCheckConfirm.checked = true;
        }
    }



    disabled_ime (){
        const formEl = document.querySelector(this.form_class);
        if(formEl){
            const alphanumerics = document.querySelectorAll(this.form_class + ' [data-alpha-numeric] input');

            const toHalfWidth = (str) => {
                return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
                    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
                });
            }
            alphanumerics.forEach( (input) => {
                input.setAttribute("style","ime-mode:disabled");
                input.addEventListener('blur',() => {
                    input.value = toHalfWidth(input.value);
                })
            });
        }
    }

    readonly() {
        const readonlyInput = document.querySelectorAll(".add-readonly");
		if(readonlyInput.length > 0) {
            readonlyInput.forEach((read) => {
                read.readOnly = true;
            })
		}
    }
    customHome() {
        const customTarget = document.getElementById("form-home__target01");
		const customElm = document.querySelector(".custom-check[value='その他']");        
		if(customTarget&&customElm) {
            customElm.addEventListener('change', function() {
                if(customElm.checked) {
                    customTarget.classList.add("active");
                }else{
                    customTarget.classList.remove("active");
                }
            })
		}

        const customTarget02 = document.getElementById("form-home__target02");
        const customElm02 = document.querySelectorAll("input[name=radio01]");
        if(customTarget02) {
            for(const elm of customElm02) {
                elm.addEventListener('change',function(){
                    if( this.checked ) {
                        if(this.value == 'リフォーム') {
                            customTarget02.classList.add("active");
                        }else{
                            customTarget02.classList.remove("active");
                        }
                    }
                });
            }
		}

        const customTarget03 = document.getElementById("form-home__target03");
        const customElm03 = document.querySelectorAll("input[name=radio01]");
        if(customTarget03) {
            for(const elm of customElm03) {
                elm.addEventListener('change',function(){
                    if( this.checked ) {
                        if(this.value == '新築') {
                            customTarget03.classList.add("active");
                        }else{
                            customTarget03.classList.remove("active");
                        }
                    }
                });
            }
		}
        
		// const customRadioElm = document.querySelector(".custom-radio[value='リフォーム']");        
		// if(customTarget02&&customRadioElm) {
        //     customRadioElm.addEventListener('change', function() {
        //         if(customRadioElm.checked) {
        //             customTarget02.classList.add("active");
        //         }else{
        //             customTarget02.classList.remove("active");
        //         }
        //     })
		// }
    }
    customPresent() {
        const customTarget01 = document.getElementById("form-present__target01");
        const customElm01 = document.querySelectorAll("input[name=radio03]");
		
        if(customTarget01) {
            for(const elm of customElm01) {
                elm.addEventListener('change',function(){
                    if( this.checked ) {
                        if(this.value == 'その他') {
                            customTarget01.classList.add("active");
                        }else{
                            customTarget01.classList.remove("active");
                        }
                    }
                });
            }
		}
    }
    customCarConsider() {
        const customTarget = document.getElementById("form-consider__target01");

		if(customTarget) {
            const customElms = document.querySelectorAll("input[name=radio01]");
            for(const elm of customElms) {
                elm.addEventListener('change',function(){
                    if( this.checked ) {
                        if(this.value == '新規加入（他社・他代理店からの切替、増車、中断契約の再開含む）') {
                            customTarget.classList.add("active");
                        }else{
                            customTarget.classList.remove("active");
                        }
                    }
                });
            }
		}

        const customTarget02 = document.getElementById("form-consider__target02");
		if(customTarget02) {
            const customElms = document.querySelectorAll("input[name=new03]");
            for(const elm of customElms) {
                elm.addEventListener('change',function(){
                    if( this.checked ) {
                        if(this.value == 'いいえ') {
                            customTarget02.classList.add("active");
                        }else{
                            customTarget02.classList.remove("active");
                        }
                    }
                });
            }
		}
    }
    customCarSupport() {
        const customTarget = document.getElementById("form-car-support__target01");
        const customCheck = document.querySelector(".custom-check01[value='納車日が未定']");
        const customElmNew01 = document.getElementById("label-for-select-new02-imperial");
        const customElmNew02 = document.getElementById("label-for-new02-year");
        const customElmNew03 = document.getElementById("label-for-new02-month");
        const customElmNew04 = document.getElementById("label-for-new02-day");

        if(customTarget) {
            const customElms = document.querySelectorAll("input[name=radio03]");
            const contactDelivery = document.querySelector('[name="contact-delivery"]')
            for(const elm of customElms) {
                elm.addEventListener('change',function(){
                    if( this.checked ) {
                        if(this.value == '納車希望') {
                            customTarget.classList.add("active");
                            if(contactDelivery){
                                contactDelivery.setAttribute('required',true);
                            }
                        }else{
                            customTarget.classList.remove("active");
                            if(contactDelivery){
                                contactDelivery.removeAttribute('required');
                            }
                        }
                    }
                });
            }
		}
        if(customCheck) {
            //console.log(customCheck)
            customCheck.addEventListener('change', function() {
                if(customCheck.checked){
                    customElmNew01.disabled = true;
                    customElmNew02.disabled = true;
                    customElmNew03.disabled = true;
                    customElmNew04.disabled = true;
                }else{
                    customElmNew01.disabled = false;
                    customElmNew02.disabled = false;
                    customElmNew03.disabled = false;
                    customElmNew04.disabled = false;
                }
            })            
        }
    }
    customEstimate01() {
        const customTarget = document.getElementById("form-estimate__target01");

        function updateCustomTarget() {
            const selectedRadio = document.querySelector("input[name=radio01]:checked");
            if (selectedRadio) {
                if (selectedRadio.value == '新規加入') {
                    customTarget.classList.add("active");
                } else {
                    customTarget.classList.remove("active");
                }
            }
        }

        if (customTarget) {
            // ページの読み込み時に状態を更新
            updateCustomTarget();

            const customElms = document.querySelectorAll("input[name=radio01]");
            for (const elm of customElms) {
                elm.addEventListener('change', function() {
                    if (this.checked) {
                        updateCustomTarget();
                    }
                });
            }
        }
        // const customTarget = document.getElementById("form-estimate__target01");

		// if(customTarget) {
        //     const customElms = document.querySelectorAll("input[name=radio01]");
        //     for(const elm of customElms) {
        //         elm.addEventListener('change',function(){
        //             if( this.checked ) {
        //                 if(this.value == '新規加入') {
        //                     customTarget.classList.add("active");
        //                 }else{
        //                     customTarget.classList.remove("active");
        //                 }
        //             }
        //         });
        //     }
		// }
    }
    customConsultation() {
        const customTarget01 = document.getElementById("label-for-consultation-check-1");
            if(customTarget01) {
            const customTarget01Txt = customTarget01.nextElementSibling;
            if(customTarget01Txt) {
                customTarget01Txt.innerHTML = '今後、株式会社カワサキライフコーポレーションから商品・サービス等に関するメールでのご案内が必要な方はチェックをつけてください。';
            }
        }
    }
    customEstimate02() {
        const customTarget01 = document.getElementById("form-estimate__btm--target01");
        const customElm01A = document.querySelector(".custom-check01[value='住宅のみに使用']");
        const customElm01B = document.querySelector(".custom-check01[value='住宅以外にも使用']");
    
        const customTarget02 = document.getElementById("form-estimate__btm--target02");
        const customElm02List = document.querySelectorAll(".custom-check02");
    
        const customCheck = document.getElementById("check-home01-1");
        let customInput01 = document.getElementById("label-for-home-postcode");
        let customInput02 = document.getElementById("label-for-home-address");
        let customInput03 = document.getElementById("label-for-home-detail-select-imperial");
        let customInput04 = document.getElementById("label-for-home-detail-year");
        let customInput05 = document.getElementById("label-for-home-detail-month");
        let customInput06 = document.getElementById("label-for-home-detail-day");
        const customHomeRadio01 = document.querySelector(".custom-radio-home-details[value='予定']");
        const customHomeRadio02 = document.querySelector(".custom-radio-home-details[value='確定']");
    
        if (customElm01A) {
            customTarget01.style.display = "none";
            customElm01A.addEventListener('click', function () {
                customTarget01.style.display = "none";
            });
        }
        if (customElm01B) {
            customElm01B.addEventListener('click', function () {
                customTarget01.style.display = "block";
            });
        }
    
        if (customTarget02 && customElm02List.length > 0) {
            customTarget02.style.display = "none";
    
            customElm02List.forEach(elm => {
                elm.addEventListener('click', function () {
                    customTarget02.style.display = elm.value === "その他" && elm.checked ? "block" : "none";
                });
            });
        }
    
        if (customCheck) {
            customCheck.addEventListener('change', function () {
                const isDisabled = customCheck.checked;
                customInput01.disabled = isDisabled;
                customInput02.disabled = isDisabled;
                customInput03.disabled = isDisabled;
                customInput04.disabled = isDisabled;
                customInput05.disabled = isDisabled;
                customInput06.disabled = isDisabled;
                customHomeRadio01.disabled = isDisabled;
                customHomeRadio02.disabled = isDisabled;
            });
        }
    }
    
    customGoods() {
        const customTarget = document.querySelectorAll(".content.content02");

        if(customTarget.length > 0) {
            const customElms = document.querySelectorAll("input[name=radio01]");
            for(const elm of customElms) {
                elm.addEventListener('change',function(){
                    if(this.checked) {
                        // customTargetの各要素に対してループを実行
                        customTarget.forEach((target) => {
                            if(this.value == 'Kawasakiグッズ・航空機グッズ') {
                                target.classList.add("active");
                            }else{
                                target.classList.remove("active");
                            }
                        });
                    }
                });
            }
        }
    }
    
    customOther() {
        const customTarget02 = document.querySelectorAll("#form-other__target01");
        const customElm02 = document.querySelectorAll("input[name=subject]");
        if(customTarget02.length > 0) {
            customTarget02.forEach( customTarget => {
                // ページが読み込まれたときに、保険が選択されているか確認し、適切にクラスを切り替える
                document.addEventListener('DOMContentLoaded', function() {
                    const checkedElm = document.querySelector("input[name=subject]:checked");
                    if(checkedElm && checkedElm.value == '保険') {
                        customTarget.classList.add("active");
                    }
                });
                for(const elm of customElm02) {
                    elm.addEventListener('change',function(){
                        if( this.checked ) {
                            if(this.value == '保険') {
                                customTarget.classList.add("active");
                            }else{
                                customTarget.classList.remove("active");
                            }
                        }
                    });
                }
            });
		}
    }

    checkMail() {
        const formEl = document.querySelector(this.form_class);
        const formSubmit = document.querySelector(this.form_class + ' input[type="submit"]');
        if(formEl){
            formSubmit.addEventListener("click",function(){
                const mail = document.getElementById("label-for-email").value;
                const mailConfirm = document.getElementById("label-for-email_confirm").value;
                if (mail != mailConfirm){
                    alert("メールアドレスと確認用メールアドレスが一致しません"); 
                    return false;
                }else{
                    return true;
                }
            })
        }
    }

    require(){
        let error = true;
        
        const formEl = document.querySelector(this.form_class);

        if(formEl){
            const formSubmit = document.querySelector(this.form_class + ' input[type="submit"]');
            const requires = document.querySelectorAll(this.form_class + ' [data-required]');
            const requiresAnys = document.querySelectorAll(this.form_class + ' [data-required-any]');
            const requiresAlls = document.querySelectorAll(this.form_class + ' [data-required-all]');
            const kanaZen = document.getElementById("label-for-zenkana");
            if(requires.length > 0){
                requires.forEach( (req) => {
                    const input = req.querySelector("input");
                    if(input){
                        if(input.getAttribute('type')=="email"){
                            input.setAttribute('pattern' ,"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$")
                        }
                        if(kanaZen){
                            kanaZen.setAttribute('pattern' ,"(?=.*?[\u30A1-\u30FC])[\u30A1-\u30FC]*")
                        }
                        input.setAttribute('required',true);
                    }
                    const select = req.querySelector("select");
                    if(select){
                        select.setAttribute('required',true);
                    }
                    const textarea = req.querySelector("textarea");
                    if(textarea){
                        textarea.setAttribute('required',true);
                    }
                })
            }
            if(requiresAnys.length > 0){
                requiresAnys.forEach( (req) => {
                    const inputs = req.querySelectorAll("input");
                    if(inputs.length > 0){
                        inputs.forEach( (input) => {
                            if(input.getAttribute('type')=="email"){
                                input.setAttribute('pattern' ,"[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$")
                            }
                            input.setAttribute('required',true);
                        })
                    }
                    const selects = req.querySelectorAll("select");
                    if(selects.length > 0){
                        selects.forEach( (select) => {
                            select.setAttribute('required',true);
                        })
                    }
                    const textareas = req.querySelectorAll("textarea");
                    if(textareas.length > 0){
                        textareas.forEach( (textarea) => {
                            textarea.setAttribute('required',true);
                        })
                    }
                })
                requiresAlls.forEach( (req) => {
                    const inputs = req.querySelectorAll("input");
                    if(inputs.length > 0){
                        inputs.forEach( (input) => {
                            input.setAttribute('required',true);
                        })
                    }
                    const selects = req.querySelectorAll("select");
                    if(selects.length > 0){
                        selects.forEach( (select) => {
                            select.setAttribute('required',true);
                        })
                    }
                    const textareas = req.querySelectorAll("textarea");
                    if(textareas.length > 0){
                        textareas.forEach( (textarea) => {
                            textarea.setAttribute('required',true);
                        })
                    }
                })
            }
            formSubmit.addEventListener("click", (e) => {
                // if(formSubmit){
                //     const formCtl = document.querySelectorAll('.form-control');
                //     formSubmit.addEventListener("click",function(){
                //         formCtl.forEach(elm => {
                //             elm.required = false;
                //         })
                //     });
                // }
                requiresAnys.forEach( (req) => {
                    const inputs = req.querySelectorAll("input");
                    const selects = req.querySelectorAll("select");
                    const textareas = req.querySelectorAll("textarea");

                    const notEmptyInputs = inputs.filter((input) => {
                        if( input.getAttribute("type") !== "hidden"){
                            if( input.getAttribute("type") == "radio" || input.getAttribute("type") == "checkbox" ){
                                return input.checked;
                            }else{
                                return input.value!=""
                            }
                        }
                    })
                    const notEmptySelects = selects.filter((select) => {
                        return select.value!="";
                    })
                    const notEmptyTextareas = textareas.filter((textarea) => {
                        return textarea.value!="";
                    })
                    if(notEmptyInputs.length > 0){
                        inputs.forEach( (input) => {
                            input.removeAttribute('required');
                        })
                    }else{
                        inputs.forEach( (input) => {
                            input.setAttribute('required',true);
                        })
                    }
                    
                    if(notEmptySelects.length > 0){
                        selects.forEach( (select) => {
                            select.removeAttribute('required');
                        })
                    }else{
                        selects.forEach( (select) => {
                            select.setAttribute('required',true);
                        })
                    }
                    if(notEmptyTextareas.length > 0){
                        textareas.forEach( (textarea) => {
                            textarea.removeAttribute('required');
                        })
                    }else{
                        textareas.forEach( (textarea) => {
                            textarea.setAttribute('required',true);
                        })
                    }
                    if(notEmptyInputs.length > 0 && notEmptySelects.length > 0 && notEmptyTextareas.length > 0){
                        error = false
                    }else{
                        error = true
                    }
                })
                if(!error){
                    formEl.submit();
                }
                return false;
            })
        }
    }

    zip (){
        const postCodeLabel = document.querySelectorAll(this.form_class + ' [data-zip]');

        if(postCodeLabel.length > 0){
            postCodeLabel.forEach(el => {
                
                const postCode = document.querySelector('#' + el.getAttribute('data-zip'));
                const name = el.getAttribute('data-address');
                postCode.addEventListener('blur',() => {
                    AjaxZip3.zip2addr(postCode,'',name,name);
                })
            })
        }
    }

    fileInput (){
        const fileLabels = document.querySelectorAll(this.form_class + ' [data-file-input]');


        const fileSelected = (label,file) => {
            const value = getFileName(file.value);
            
            if(value!=""){
                label.innerText = value;
            }else{
                label.innerText = file.getAttribute('data-default-value');
            }
        }
        const getFileName = (value) => {
			var regex = /\\|\\/;
			var array = value.split(regex);
			return array[array.length - 1];	
        }
        
        
        if(fileLabels.length > 0){
            fileLabels.forEach((label) =>{
                const file = document.querySelector('#' + label.getAttribute('for'))
                file.setAttribute('data-default-value',label.innerText);
                file.addEventListener('change',() => {
                    fileSelected(label,file)
                })
            })
        }
    }

    

	appendApi (){
        const script = document.createElement('script');
        script.setAttribute("src", this.ajaxZipUrl ); 
        document.body.appendChild(script);
    }
    

    select_multi_dates (){
        const place = document.querySelector("[data-selects-place] select")
        const dates = document.querySelector("[data-selects-date]")
        const times = document.querySelector("[data-selects-time]")
        const values_el = document.querySelector('[data-dates-values]')
        const unpreferred = document.querySelector('.unpreferred-time')

        if(place){
            
            const dates_select = dates.querySelector("select") 
            const times_select = times.querySelector("select")
            const date_values = JSON.parse(values_el.dataset.datesValues)
            const time_values = JSON.parse(values_el.dataset.timesValues)

            dates_select.style.display = "none"
            dates_select.innerHTML = ""

            times_select.style.display = "none"
            times_select.innerHTML = ""
            
            const hide_date = () => {
                dates_select.style.display = "none"
                dates_select.innerHTML = ""
            }
            const hide_time = () => {
                times_select.style.display = "none"
                times_select.innerHTML = ""
                if(unpreferred){
                    unpreferred.style.display = "block"
                }
            }

            place.addEventListener("change",()=>{
                const key = place.value

                dates_select.value = ""
                times_select.value = ""

                let date_html = ""
                if(date_values.hasOwnProperty(key)){
                    if(Array.isArray(date_values[key])){
                        date_values[key].forEach(d => {
                            date_html += "<option value=" + d  + ">" + d + "</option>"
                        })
                        dates_select.style.display = "block"
                        dates_select.innerHTML = date_html
                    }else{
                        hide_date()
                    }
                }else{
                    hide_date()
                }

                let time_html = ""
                if(time_values.hasOwnProperty(key)){
                    if(Array.isArray(time_values[key])){
                        time_values[key].forEach(d => {
                            time_html += "<option value=" + d  + ">" + d + "</option>"
                        })
                        times_select.style.display = "block"
                        times_select.innerHTML = time_html
                        if(unpreferred){
                            unpreferred.style.display = "none"
                        }
                    }else{
                        hide_time()
                    }
                }else{
                    hide_time()
                }
            })
        }
    }
}